export function getAvatar(username?: string) {
    if (!username) return '/assets/shared/image/avatar.svg'
    return `https://ui-avatars.com/api/?name=${username}&background=random`
}
